<!-- cv简历信息表-奖项-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <div v-if='awardsDetailCn.awards && awardsDetailCn.awards.length > 0'>
          <ul v-for='(item, index) in awardsDetailCn.awards'
              :key='index'>
            <li>
              <span class='cv-detail-name'>奖项名称：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>获得时间：</span>
              <span class='cv-detail-val'>{{item.time}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>获得年级：</span>
              <!-- <span class='cv-detail-val'>{{item.grades && new Map(gradeCnMap).get(item.grades)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.grades && item.grades.length > 0'><span v-for='(grade, idx) in item.grades'
                      :key='idx'>{{new Map(gradeCnMap).get(grade)}}<span v-if='idx !== item.grades.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>奖项级别：</span>
              <span class='cv-detail-val'>{{item.level && new Map(awardLevelCnMap).get(item.level)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>颁奖单位：</span>
              <span class='cv-detail-val'>{{item.issuedBy}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>奖项描述：</span>
              <span class='cv-detail-val'>{{item.description}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <div v-if='awardsDetailEn.awards && awardsDetailEn.awards.length > 0'>
          <ul v-for='(item, index) in awardsDetailEn.awards'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Honor Name：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Date：</span>
              <span class='cv-detail-val'>{{item.time}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Grade Level：</span>
              <!-- <span class='cv-detail-val'>{{item.grades && new Map(gradeEnMap).get(item.grades)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.grades && item.grades.length > 0'><span v-for='(grade, idx) in item.grades'
                      :key='idx'>{{new Map(gradeEnMap).get(grade)}}<span v-if='idx !== item.grades.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>Level of Recognition：</span>
              <span class='cv-detail-val'>{{item.level && new Map(awardLevelEnMap).get(item.level)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Issued by：</span>
              <span class='cv-detail-val'>{{item.issuedBy}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Description：</span>
              <span class='cv-detail-val'>{{item.description}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              :label-width="300">
          <div class="base-form-wrap"
               v-if='formValidateCn.awards && formValidateCn.awards.length > 0'>
            <div class="base-form-item"
                 v-for='(item, index) in formValidateCn.awards'
                 :key='index'>
              <FormItem label="奖项名称："
                        :prop="`awards.${index}.name`"
                        :rules="[{required: true, message: '请输入奖项名称'}]">
                <Input v-model="item.name"
                       placeholder="请输入奖项名称"
                       clearable></Input>
              </FormItem>
              <FormItem label="获得时间："
                        :prop="`awards.${index}.time`"
                        :rules="[{required: true, message: '请选择'}]">
                <date-picker-wrapper type="month"
                                     format='yyyy-MM'
                                     placeholder="请选择"
                                     :editable='false'
                                     v-model="item.time"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
              <FormItem label="获得年级："
                        :prop="`awards.${index}.grades`"
                        :rules="[{required: true, message: '请选择'}]">
                <CheckboxGroup v-model="item.grades">
                  <Checkbox v-for="grade in gradeCnMap"
                            :label="grade[0]"
                            :value="grade[0]"
                            :key="grade[0]">{{grade[1]}}</Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="奖项级别："
                        :prop="`awards.${index}.level`"
                        :rules="[{required: true, message: '请选择'}]">
                <Select v-model="item.level"
                        placeholder="请选择"
                        clearable>
                  <Option v-for="single in awardLevelCnMap"
                          :value="single[0]"
                          :key="single[0]">{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="奖项单位："
                        :prop="`awards.${index}.issuedBy`"
                        :rules="[{required: true, message: '请输入颁奖单位'}]">
                <Input v-model="item.issuedBy"
                       placeholder="请输入颁奖单位"
                       clearable></Input>
              </FormItem>
              <FormItem label="奖项描述："
                        :prop="`awards.${index}.description`"
                        :rules="[{required: true, message: '请简要介绍奖项信息'}]">
                <Input type='textarea'
                       :rows='5'
                       v-model="item.description"
                       placeholder="请简要介绍奖项信息"></Input>
              </FormItem>
              <div class='oper-del'>
                <a href='javascript: void(0)'
                   @click="delCn(item, index)">删除</a>
              </div>
            </div>
          </div>
          <div class='oper-add'>
            <a href='javascript: void(0)'
               @click="addCn">添加</a>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveCn'
                    @click="saveCn">保存</Button>
          </div>
        </Form>
      </div>
      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-wrap"
               v-if='formValidateEn.awards && formValidateEn.awards.length > 0'>
            <div class="base-form-item"
                 v-for='(item, index) in formValidateEn.awards'
                 :key='index'>
              <FormItem label="Honor Name："
                        :prop="`awards.${index}.name`"
                        :rules="[{required: true, message: 'Please enter Honor Name'}]">
                <Input v-model="item.name"
                       placeholder="please use the official name of the award"
                       clearable></Input>
              </FormItem>
              <FormItem label="Date："
                        :prop="`awards.${index}.time`"
                        :rules="[{required: true, message: 'Please select'}]">
                <date-picker-wrapper type="month"
                                     format='yyyy-MM'
                                     :editable='false'
                                     placeholder="yyyy.mm, E.g. 2018.08"
                                     v-model="item.time"
                                     style="width:100%;"></date-picker-wrapper>
              </FormItem>
              <FormItem label="Grade Level："
                        :prop="`awards.${index}.grades`"
                        :rules="[{required: true, message: 'Please select'}]">
                <CheckboxGroup v-model="item.grades">
                  <Checkbox v-for="grade in gradeEnMap"
                            :label="grade[0]"
                            :value="grade[0]"
                            :key="grade[0]">{{grade[1]}}</Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="Level of Recognition："
                        :prop="`awards.${index}.level`"
                        :rules="[{required: true, message: 'Please select'}]">
                <Select v-model="item.level"
                        placeholder="Please select"
                        clearable>
                  <Option v-for="single in awardLevelEnMap"
                          :value="single[0]"
                          :key="single[0]">{{single[1]}}
                  </Option>
                </Select>
              </FormItem>
              <FormItem label="Issued by："
                        :prop="`awards.${index}.issuedBy`"
                        :rules="[{required: true, message: 'Please enter'}]">
                <Input v-model="item.issuedBy"
                       placeholder="please use the official title of the institution or the host of the event"
                       clearable></Input>
              </FormItem>
              <FormItem label="Description："
                        :prop="`awards.${index}.description`"
                        :rules="[{required: true, message: 'please enter the description'}]">
                <Input type='textarea'
                       :rows='5'
                       v-model="item.description"
                       placeholder="please briefly describe the award"></Input>
              </FormItem>
              <div class='oper-del'>
                <a href='javascript: void(0)'
                   @click="delEn(item, index)">Delete</a>
              </div>
            </div>
          </div>
          <div class='oper-add'>
            <a href='javascript: void(0)'
               @click="addEn">Add</a>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveEn'
                    @click="saveEn">Save</Button>
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEditCn">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { gradeCnMap, gradeEnMap, awardLevelCnMap, awardLevelEnMap } from '../constants'
import './cv-detail.less'
import DatePickerWrapper from '@/components/date/DatePickerWrapper'
export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: { DatePickerWrapper },
  data () {
    return {
      // 年级映射
      gradeCnMap,
      gradeEnMap,
      // 奖项级别映射
      awardLevelCnMap,
      awardLevelEnMap,
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // 奖项详情
      awardsDetailCn: {},
      awardsDetailEn: {},
      // Cn表单
      formValidateCn: {
        awards: [
          // {
          //   name: '',
          //   time: '',
          //   grades: '',
          //   level: '',
          //   issuedBy: '',
          //   description: ''

          // }
        ]
      },
      ruleValidateCn: {},
      // En表单
      formValidateEn: {
        awards: [
          // {
          //   name: '',
          //   time: '',
          //   grades: '',
          //   level: '',
          //   issuedBy: '',
          //   description: ''

          // }
        ]
      },
      ruleValidateEn: {},
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getAwardsDetailCn()
      }
      if (this.lang === 'en') {
        this.getAwardsDetailEn()
      }
    })
  },
  methods: {
    // 获取奖项-cn
    getAwardsDetailCn () {
      cvService.cvAwardsDetailCn().then(res => {
        if (res.data.model) {
          this.awardsDetailCn = res.data.model
          this.formValidateCn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取奖项-en
    getAwardsDetailEn () {
      cvService.cvAwardsDetailEn().then(res => {
        if (res.data.model) {
          this.awardsDetailEn = res.data.model
          this.formValidateEn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEditCn () {
      this.isEditCn = !this.isEditCn
      this.getAwardsDetailCn()
    },
    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getAwardsDetailEn()
    },
    // 删除
    delCn (item, index) {
      this.formValidateCn.awards.splice(index, 1)
    },
    // Delete
    delEn (item, index) {
      this.formValidateEn.awards.splice(index, 1)
    },
    // 添加
    addCn () {
      this.formValidateCn.awards.push(
        {
          name: '',
          time: '',
          grades: [],
          level: '',
          issuedBy: '',
          description: ''
        }
      )
    },
    // Add
    addEn () {
      this.formValidateEn.awards.push(
        {
          name: '',
          time: '',
          grades: [],
          level: '',
          issuedBy: '',
          description: ''
        }
      )
    },
    // 保存
    saveCn () {
      if (this.awardsDetailCn.awards && this.awardsDetailCn.awards.length === 0) {
        this.hasSaveCn = true
        // 调用接口
        cvService.cvSaveAwardsCn(this.formValidateCn).then(res => {
          this.hasSaveCn = false
          this.isEditCn = false
          this.$ugd_message('保存成功', 'success')
          this.getAwardsDetailCn()
          // 调用详情接口
        }).catch(error => {
          this.hasSaveCn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateCn.validate((valid) => {
        if (valid) {
          this.hasSaveCn = true
          // 调用接口
          cvService.cvSaveAwardsCn(this.formValidateCn).then(res => {
            this.hasSaveCn = false
            this.isEditCn = false
            this.$ugd_message('保存成功', 'success')
            this.getAwardsDetailCn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveCn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    // Save
    saveEn () {
      if (this.awardsDetailEn.awards && this.awardsDetailEn.awards.length === 0) {
        this.hasSaveEn = true
        // 调用接口
        cvService.cvSaveAwardsEn(this.formValidateEn).then(res => {
          this.hasSaveEn = false
          this.isEditEn = false
          this.$ugd_message('Save Success', 'success')
          this.getAwardsDetailEn()
          // 调用详情接口
        }).catch(error => {
          this.hasSaveEn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          this.hasSaveEn = true
          // 调用接口
          cvService.cvSaveAwardsEn(this.formValidateEn).then(res => {
            this.hasSaveEn = false
            this.isEditEn = false
            this.$ugd_message('Save Success', 'success')
            this.getAwardsDetailEn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveEn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
